<input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
(change)="onFileSelected($event)" #fileUpload required>

<ng-container *ngIf="!editingAuthor">
    <h2>{{selectedAuthor?.firstName}} {{selectedAuthor?.lastName}}</h2>
    <p><label class="fixed-size">First Name:</label> <strong>{{selectedAuthor?.firstName}}</strong></p>
    <p><label class="fixed-size">Last Name:</label> <strong>{{selectedAuthor?.lastName}}</strong></p>
    <p><label class="fixed-size">Bio:</label> <label class="indent"><strong>{{selectedAuthor?.bio}}</strong></label></p>

    <button class="primary-button" type="add" (click)="this.editAuthor()">Edit Author</button>
</ng-container>
<ng-container *ngIf="editingAuthor">
    <h2>Editing:  {{selectedAuthor?.firstName}} {{selectedAuthor?.lastName}}<button class="delete-button" type="delete" (click)="this.removeAuthor()">Delete Author</button></h2>
    <br>
    <form [formGroup]="authorForm">
        <label class="fixed-size" for="first-name">First Name: </label>
        <input id="first-name" type="text" formControlName="firstName">
        <br>
        <label class="fixed-size" for="last-name">Last Name: </label>
        <input id="last-name" type="text" formControlName="lastName">
        <br>
        <div *ngIf="newFile != undefined; else noFile">
          <label class="fixed-size" for="author-image">Author Image: </label>
          <label>{{newFileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
        </div>
        <ng-template #noFile>
          <label  for="author-image">Replace Author Image: </label>
          <button class="add-button" (click)="fileUpload.click()">New Image</button>
        </ng-template>
        <br>
        <label for="bio">Bio: </label><br>
        <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
          formControlName="bio"></textarea>
        <br>
      </form>
      <form [formGroup]="authorForm" (ngSubmit)="submitAuthorEdits()"></form>
      <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
      <button class="primary-button" type="submit" [disabled]="!authorForm.valid" (click)="this.submitAuthorEdits()">Submit</button>
</ng-container>